/**
 * Persist explicit operator escalation from an OPERATIONAL mission to Engineering Intelligence.
 * Without this flag, ops-classified incidents stay on the ops remediation pipeline.
 */
const PREFIX = 'ensomirai.ei-escalate.';

function key(projectId: string, incidentId: string): string {
  return `${PREFIX}${projectId}:${incidentId}`;
}

export function isEiEscalatedForIncident(
  projectId?: string | null,
  incidentId?: string | null,
): boolean {
  if (!projectId || !incidentId || typeof window === 'undefined') return false;
  try {
    return window.sessionStorage.getItem(key(projectId, incidentId)) === '1';
  } catch {
    return false;
  }
}

export function setEiEscalatedForIncident(
  projectId: string,
  incidentId: string,
  escalated = true,
): void {
  if (typeof window === 'undefined') return;
  try {
    const k = key(projectId, incidentId);
    if (escalated) window.sessionStorage.setItem(k, '1');
    else window.sessionStorage.removeItem(k);
  } catch {
    /* ignore quota / private mode */
  }
}
